/**
 *  Initialize searchBar
 *
 *  All scripts for the search bar functionality
 */
var searchBar = (function ($) {

  var pub = {}; // public facing functions

  pub.init = function () {
    const searchBarElement = $('.search-container'),
      searchToggle = $('.search-toggle'),
      siteNavElementWidth = $('.site-navigation > .container > .row > .navbar-default').width(),
      shopButtonWidth = $('.shop-button-container').width(),
      calculatedWidth = siteNavElementWidth - shopButtonWidth;

    let isActive = false;

    searchBarElement.css({
      'width': calculatedWidth + 'px'
    });

    searchToggle.on('click', function(e) {
      e.stopPropagation();

      if (searchToggle.hasClass('active') && searchBarElement.hasClass('active')) {
        searchToggle.removeClass('active');
        searchBarElement.removeClass('active');
        isActive = false;
      } else {
        searchToggle.addClass('active');
        searchBarElement.addClass('active');
        isActive = true;
        $('input.form-control').focus();
        $('.menu-item').removeClass('open');
      }
    });

    // Close the search bar if clicking anywhere else on the page
    $(document).click(function(e) {
      if (e.target.id === 'search-container' || $(e.target).parents('#search-container').length) {
        return;
      } else if (isActive === true) {
        searchToggle.removeClass('active');
        searchBarElement.removeClass('active');
        isActive = false;
      }
    });

    //Close search bar if clicking anywhere in menu
    $('.dropdown').on('show.bs.dropdown', function(){
      if (searchToggle.hasClass('active') && searchBarElement.hasClass('active')) {
        searchToggle.removeClass('active');
        searchBarElement.removeClass('active');
        isActive = false;
      }
    })

  };

  return pub;

}(jQuery));
